
import React from 'react';

const DefaultSVG = () =>
  <svg height="54px" width="53px" version="1.1" viewBox="0 0 53 54">
    <g fill="none" stroke="none" strokeWidth="1">
      <g transform="translate(-195.000000, -257.000000)">
        <g transform="translate(157.000000, 115.000000)">
          <g transform="translate(-1.000000, 107.000000)">
            <g transform="translate(39.000000, 33.000000)">
              <g transform="translate(0.000000, 2.000000)">
                <rect height="53.7479069" width="52.1574875" fill="#ECECEC" rx="26.0787437" x="0" y="0"/>
                <polygon points="12.8445073 14 38.8445073 14 38.8445073 40 12.8445073 40"/>
                <g transform="translate(14.000000, 15.000000)">
                  <rect height="23.0911239" width="23.7058594" fill="#FFFFFF" rx="3" transform="translate(11.906452, 11.979060) rotate(90.000000) translate(-11.906452, -11.979060) " x="0.0535219254" y="0.433498242"/>
                  <path d="M23.7058594,14.7805139 L23.7058594,21.5009299 C23.7058594,23.1333423 22.177815,24.4566741 20.2967733,24.4566741 L3.40908608,24.4566741 C1.52629983,24.4566741 2.48689958e-14,23.1315341 2.48689958e-14,21.5009299 L2.48689958e-14,14.7805139 L23.7058594,14.7805139" fill="#EB5424"/>
                  <rect height="1.95687491" width="12.8562212" fill="#000000" rx="0.978437454" x="5.4" y="4.45281347"/>
                  <rect height="1.95687491" width="12.8562212" fill="#000000" rx="0.978437454" x="5.4" y="8.56225078"/>
                  <rect height="1.95687491" width="7.81455825" fill="#FFFFFF" rx="0.978437454" x="7.94565056" y="18.7380003"/>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>;

export default DefaultSVG;


// WEBPACK FOOTER //
// ./src/svg/DefaultSVG.js